// @flow
import * as React from "react";
import { connect } from "react-redux";
import { getCurrentUser } from "src/reducers";
import { isMobile } from "react-device-detect";

import Loader from "src/components/auth/Loader";
import type { UnifizeUser, AppState } from "src/types";

type Props = {
  user: UnifizeUser & { emailVerified: boolean },
  children: React.Node,
};

const LoaderWrapper = ({ user, children }: Props) => {
  const { displayName, email, uid, emailVerified } = user;
  const showLoader = uid && emailVerified && !isMobile;
  if (showLoader) {
    return <Loader displayName={displayName} email={email} />;
  }
  return children;
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  user: getCurrentUser(app),
});

export default connect(mapStateToProps, {})(LoaderWrapper);
